$(window.document).ready(function (e) {
    $('#form-lavora-con-noi').validate({
        submitHandler: function() {
            var formData = new FormData($('#form-lavora-con-noi')[0]);

            $('#overlay').show();

            if ($('#caricaCV').val() != undefined) {
                formData.append('caricaCV', $('input[type=file][id="caricaCV"]')[0].files[0]);
            }

            $.ajax({
                type: 'POST',
                url: '/inviacurriculum',
                data: formData,
                cache: false,
                mimeType: 'multipart/form-data',
                contentType: false,
                processData: false,
                success: function (data) {
                    data = JSON.parse(data);
                    window.location.href = data.redirectUrl;
                },
                // error : function(error) {
                //     $('#form-lavora-con-noi-error').show()
                // }
                error: function(xhr, status, error) {
                    if(xhr.status === 413){
                        $('#form-lavora-con-noi-error-413').show();
                        $('#form-lavora-con-noi input[type="file"]').val('');
                        setTimeout(function() {
                            $('#form-lavora-con-noi-error-413').fadeOut(500, function(){
                                (this).remove();
                            });
                        }, 5000);
                    }
                    else {
                        $('#form-lavora-con-noi-error').show()
                    }
                },
                complete: function() {
                    $('#overlay').hide();
                }
            });
         
        }
    });

    // $('#form-lavora-con-noi').submit(function (event) {
    //     // validateFormLavoraConNoi("#form-lavora-con-noi");
    //     event.stopPropagation();
    //     event.preventDefault();
    //     var formData = new FormData($('#form-lavora-con-noi')[0]);

    //     if ($("#caricaCV").val() != undefined) {
    //         formData.append('caricaCV', $("input[type=file][id='caricaCV']")[0].files[0]);
    //     }

    //     $.ajax({
    //         type: "POST",
    //         url: '/inviacurriculum',
    //         data: formData,
    //         cache: false,
    //         mimeType: "multipart/form-data",
    //         contentType: false,
    //         processData: false,
    //         success: function (data) {
    //             data = JSON.parse(data);
    //             console.log(data.redirectUrl);
    //             window.location.href = data.redirectUrl;
    //         },
    //         error : function(error) {
    //             var errors = JSON.parse(error.responseText);
    //             //ripristina le classi errori
    //             $(".form-group").removeClass("has-error");
    //             //ripristina i messaggi di errore
    //             $(".help-block.form-error").remove();
    //             for (var prop in errors) {
    //                 var element = $("#" + prop);
    //                 element.parent().addClass("has-error");
    //                 element.parent().append('<span class="help-block form-error"><font>' + errors[prop] + '</font></span>')
    //             }

    //         }

    //     });
    // });
});

// function validateFormLavoraConNoi(idForm) {
//     validatorExt(idForm);
//     $(idForm).validate({
//         ignore: [],
//         focusInvalid: false,
//         errorPlacement: function (error, element) {
//             if (element.attr("name")) {
//                 if (element.attr("name") == "email")
//                     error.insertAfter('#email');

//                 if (element.attr("name") == 'motivazione') {
//                     $("input[name=" + element.attr("name") + "]").parent().parent().attr("style", "color:red");
//                 } else if (element.attr("name") == 'tipologia') {
//                     $("label[for=" + element.attr("id") + "]").attr("style", "color:red");
//                     $("select[name=" + element.attr("name") + "]").parent().find("button").attr("style", "border: 1px solid red;");
//                 } else if (element.attr("name") == 'provinciaLav') {
//                     $("select[name=" + element.attr("name") + "]").parent().find("button").attr("style", "border: 1px solid red;");
//                 } else {
//                     $("label[for=" + element.attr("id") + "]").attr("style", "color:red");
//                 }
//             }
//             return true;
//         },
//         rules: {
//             nome: {
//                 isNomeOCognome: true
//             },
//             cognome: {
//                 isNomeOCognome: true
//             },
//             email: {
//                 isMailOrTel: true
//             },
//             telefono: {
//                 isMailOrTel: true,
//             numberTelefono:true
//             },
//             caricaCV: {
//                 required: true
//             },
//             tipologia: {
//                 required: true
//             },
//             motivazione: {
//                 required: true,
//             },
//             provinciaLav: {
//                 required: true,
//             },
//             privacy_imm: {
//                 required: true,
//             }
//         },
//         messages: {
//             email: {
//                 verifyemail: "Email inserita non valida!"
//             }
//         }
//     });

//     $(idForm).on("focusout", ".bootstrap-select", function () {
//         if ($(this).parent().find("button").attr("style") == 'border: 1px solid red;') {
//             if ($(this).find("select").valid()) {
//                 $(this).parent().find("button").css("border", "1px solid #ccc");
//                 $(this).parent().find("button").parent().parent().parent().find("label").css("color", "#5a5a5c");
//             }
//         }
//     });

//     $(idForm).on("change", "input", function () {
//         var nome = $(this).attr("id");
//         if (nome == 'fc_nome' || nome == 'fc_cognome') {
//             if ($(this).valid()) {
//                 $("#fc_nome").removeClass("error");
//                 $("#fc_cognome").removeClass("error");
//             }
//         } else if (nome == 'fc_telefono' || nome == 'fc_email') {
//             if ($(this).valid()) {
//                 $("#fc_telefono").removeClass("error");
//                 $("#fc_email").removeClass("error");
//             }
//         }
//         if (nome == 'labelfc_motivazioneVendita' || nome == 'labelfc_motivazioneAffitto') {
//             if ($(this).valid()) {
//                 $(this).parent().parent().removeAttr("style");
//             } else {
//                 $(this).parent().parent().attr("style", "color:red");
//             }
//         } else if ($("label[for=" + nome + "]").attr("style") == 'color:red') {

//             if ($(this).valid()) {
//                 $(this).css("border", "1px solid #ccc");
//                 $(this).parent().parent().find("label").css("color", "#5a5a5c");

//                 if ($(idForm + ' #email-error').length > 0) {
//                     $(idForm + ' #email-error').remove();
//                 }
//             } else {
//                 $(this).css("border", "2px solid red");
//                 $(this).parent().parent().find("label").css("color", "red");
//             }
//         }
//     });
// }
// if ($("#form-lavora-con-noi").length > 0) {
//     validateFormLavoraConNoi("#form-lavora-con-noi");

//     $('#form-lavora-con-noi').submit(/*"submit","#inviaFormContatti", */function (event) {
//         console.log(44444)
//         event.preventDefault();
//         if ($("#form-lavora-con-noi").valid()) {
//             $(this).prop("disabled",true);
//             var formData = new FormData($('#form-lavora-con-noi')[0]);

//             if ($("#caricaCV").val() != undefined) {
//                 formData.append('caricaCV', $("input[type=file][id='caricaCV']")[0].files[0]);
//             }

//             $.ajax({
//                 type: "POST",
//                 url: '/inviacurriculum',
//                 data: formData,
//                 cache: false,
//                 mimeType: "multipart/form-data",
//                 contentType: false,
//                 processData: false,
//                 success: function (data) {

//                     if (data == 'OK') {
//                         location.href = $("#inviaForm").attr("data-conferma");
//                     }
//                 }
//             });
//         }
//     });
// }